<template>
  <component
    :is="componentTag"
    v-bind="componentProps"
    class="btn"
    :class="classes"
  >
    <slot />
  </component>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  name: 'UIButton',
  props: {
    to: { type: String, default: null },
    href: { type: String, default: null },
    variant: { type: String, default: 'primary' }, // primary, outline
    size: { type: String, default: 'md' }, // md, sm
    type: { type: String, default: 'button' }
  },
  computed: {
    componentTag() {
      if (this.to) return RouterLink
      if (this.href) return 'a'
      return 'button'
    },
    componentProps() {
      if (this.to) return { to: this.to }
      if (this.href) return { href: this.href }
      return { type: this.type }
    },
    classes() {
      return [
        this.variant === 'outline' ? 'btn-outline' : 'btn-primary',
        this.size === 'sm' ? 'btn-sm' : ''
      ]
    }
  }
}
</script>

<style scoped>
.btn-sm { padding: 8px 14px; font-weight: 600; }
</style>


